import { gql } from "@apollo/client";
import { Organization } from "@App/types";

export interface GaragePremiumServicesQuery {
  organization: Organization;
}

export const GET_GARAGE_PREMIUM_SERVICES = gql`
    query getGaragePremiumServices($organization: ID!, $garage: ID, $services: [ID], $driverID: UUID, $presetFilters: [PresetFilter], $network: ID) {
        organization(id: $organization) {
            id
            uuid
            garages(id: $garage, services: $services, driver: $driverID, presetFilters: $presetFilters, networkId: $network) {
                data {
                    id
                    uuid
                    premium_services(services: $services) {
                        id
                        name
                        paid
                        type
                        service_type
                    }
                }
            }
        }
    }
`;
